
const technologies = [
    {
        id: 1,
        name: 'Vue.js',
        src: './technologies/vue-js.svg'
    },
    {
        id: 2,
        name: 'Spring Boot',
        src: './technologies/spring-boot.svg'
    },
    {
        id: 3,
        name: 'Angular',
        src: './technologies/angular.svg'
    },
    {
        id: 4,
        name: 'Node.js',
        src: './technologies/node-js.svg'
    },
    {
        id: 5,
        name: 'Laravel',
        src: './technologies/laravel.svg'
    },
    {
        id: 6,
        name: 'React',
        src: './technologies/react.svg'
    },
    {
        id: 6,
        name: 'Experiment',
        src: './technologies/experiment.svg'
    },
];


export default technologies;